import React from "react";
import profile from "../../images/user.png";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { GET_REVIEW } from "../../query/getReview";
import { GET_CLUB_REVIEW } from "../../query/getClubReview";
import { VIEW_ROLE } from "../../query/ViewRole";
import StarRatings from "react-star-ratings";

const Review = () => {

  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  const { data: reviewData } = useQuery(GET_REVIEW, {
    client: hasuraClient,
    variables: {
      business_profile_id: localStorage.getItem("profile_id"),
    },
  });
  const { data: clubReviewData } = useQuery(GET_CLUB_REVIEW, {
    client: hasuraClient,
    variables: {
      club_profile_id: localStorage.getItem("profile_id"),
    },
  });

  return (userRole?.users[0].role==="business" ? 
    <div className="review-block">
      <div className="main-title">
        <h2>
          Reviews
          <span className="count">
            ({reviewData?.business_reviews_aggregate?.aggregate?.count})
          </span>
        </h2>

        <StarRatings
          rating={reviewData?.average_rating?.aggregate?.avg?.rating ?? 0}
          starRatedColor="#F9BA1A"
          numberOfStars={5}
        />
      </div>
      <ul className="review-list">
        {reviewData?.business_reviews?.map((item) => (
          <li>
            <div className="review-box">
              <div className="review-header">
                <div className="user-photo">
                  <img
                    src={
                      item?.user_view?.profile_photo &&
                      item?.user_view?.profile_photo !== "null"
                        ? item?.user_view?.profile_photo
                        : profile
                    }
                    alt="profile photo"
                  />
                </div>
                <h3> {item?.user_view?.full_name} </h3>

                <div className="rating-row">
                  <StarRatings
                    rating={item?.rating}
                    starRatedColor="#F9BA1A"
                    numberOfStars={5}
                  />
                  {/* <div className="image">
                    <img src={star} alt="Star" />
                  </div>
                  <div className="image">
                    <img src={star} alt="Star" />
                  </div>
                  <div className="image">
                    <img src={star} alt="Star" />
                  </div>
                  <div className="image">
                    <img src={star} alt="Star" />
                  </div>
                  <div className="image">
                    <img src={star} alt="Star" />
                  </div> */}
                </div>
              </div>
              <p>{item?.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </div> : <div className="review-block">
      <div className="main-title">
        <h2>
          Reviews
          <span className="count">
            ({clubReviewData?.club_reviews_aggregate?.aggregate?.count})
          </span>
        </h2>

        <StarRatings
          rating={clubReviewData?.average_rating?.aggregate?.avg?.rating ?? 0}
          starRatedColor="#F9BA1A"
          numberOfStars={5}
        />
      </div>
      <ul className="review-list">
        {clubReviewData?.club_reviews?.map((item) => (
          <li>
            <div className="review-box">
              <div className="review-header">
                <div className="user-photo">
                  <img
                    src={
                      item?.user_view?.profile_photo &&
                      item?.user_view?.profile_photo !== "null"
                        ? item?.user_view?.profile_photo
                        : profile
                    }
                    alt="profile photo"
                  />
                </div>
                <h3> {item?.user_view?.full_name} </h3>

                <div className="rating-row">
                  <StarRatings
                    rating={item?.rating}
                    starRatedColor="#F9BA1A"
                    numberOfStars={5}
                  />
                  {/* <div className="image">
                    <img src={star} alt="Star" />
                  </div>
                  <div className="image">
                    <img src={star} alt="Star" />
                  </div>
                  <div className="image">
                    <img src={star} alt="Star" />
                  </div>
                  <div className="image">
                    <img src={star} alt="Star" />
                  </div>
                  <div className="image">
                    <img src={star} alt="Star" />
                  </div> */}
                </div>
              </div>
              <p>{item?.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Review;
